module.exports = __webpack_public_path__ + "static/media/ic-technology.cbe0bcce.svg";